import * as React from 'react';
import { createStyles, makeStyles } from '@mui/styles';
import { Typography, Theme } from '@mui/material';

export interface IPage404Props {

}

const styles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            marginBottom: theme.spacing(1),
        }
    })
);

const Page404: React.FunctionComponent<IPage404Props> = (props: IPage404Props) => {
    const classes = styles();

    return (
        <>
            <Typography variant="h3" className={classes.title}>Page not found</Typography>
        </>
    );
}

export default Page404;